import { useState } from 'react';

import { TabsUI } from '../Interface';
import ExcelImportTab from '../Interface/ExcelImportTab';
import EmployeeAttendanceLine from './EmployeeAttendanceLine';

const EmployeeAttendanceTabs = (props) => {
  const [activeTab, setActiveTab] = useState(0);

  const tabs = [
    {
      id: 0,
      name: 'Tétel',
      content: <EmployeeAttendanceLine {...props} />,
    },
    {
      id: 1,
      name: 'Adat import',
      content: <ExcelImportTab {...props} />,
    },
  ];

  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
  };

  return (
    <div className="my-4">
      <div className="px-3">
        <TabsUI activeTab={activeTab} handleTabClick={handleTabClick}>
          {tabs.map((tab, index) => (
            <div key={index} name={tab.name}>
              {tab.content}
            </div>
          ))}
        </TabsUI>
      </div>
    </div>
  );
};

export default EmployeeAttendanceTabs;
